import './resources-path';
import Vue from 'vue';
import Meta from 'vue-meta';
import App from './app/app.vue';
import store from './app/app-state';
import router from './app/app-routes';
import mixins from './app/app-mixins';
import './app/app-filters';
import { translate } from '@jobleads-frontend/ui_library';

import VueLazyload from 'vue-lazyload';

// Transpiler for older browsers
import 'core-js/stable';
// optional but required for transforming generator fns.
import 'regenerator-runtime/runtime';

import './scss/Main.scss';

require('dotenv').config();

Vue.config.productionTip = false;
Vue.use(Meta);
Vue.use(VueLazyload);

// eslint-disable-next-line import/prefer-default-export
export const bus = new Vue();

// @ts-ignore
window.bootApp = () => {
  window.translate = window.translate || translate;
  new Vue({
    store,
    router,
    mixins,
    render: (h) => h(App),
  }).$mount('#app');
};

// setTimeout(() => {
//   // @ts-ignore
//   window.bootApp();
// }, 1000);
